import { render, staticRenderFns } from "./ChannelContractSetEdit.vue?vue&type=template&id=1655377a&scoped=true"
import script from "./ChannelContractSetEdit.vue?vue&type=script&lang=js"
export * from "./ChannelContractSetEdit.vue?vue&type=script&lang=js"
import style0 from "./ChannelContractSetEdit.vue?vue&type=style&index=0&id=1655377a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1655377a",
  null
  
)

export default component.exports